/**
 * DROPDOWN OVERLAY TOKENS (shared by select, multiselect)
 * Source: 🔧 Custom — not defined in Figma component tokens
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createDropdownOverlayTokens(s: SemanticTokens) {
  return {
  bg: s.surface.ground,                       // --dropdown-overlay-bg: var(--surface-ground)
  border: s.border.default,                   // --dropdown-overlay-border: var(--border-default)
  fg: s.text.secondary,                       // --dropdown-overlay-fg: var(--text-secondary)
  shadow: s.shadow.md,                        // --dropdown-overlay-shadow
  radius: s.radius.md,                        // --dropdown-overlay-radius: var(--radius-8)
  transition: s.transition.normal,              // --dropdown-overlay-transition
  listPadding: s.layout.padding.xs,           // --dropdown-list-padding
  listGap: s.layout.gap.xs,                   // --dropdown-list-gap
  option: {
    fg: s.text.secondary,                    // --dropdown-option-fg: var(--text-secondary)
    fgFocus: s.text.secondary,               // --dropdown-option-fg-focus
    fgSelected: s.text.primary,              // --dropdown-option-fg-selected: var(--text-primary)
    bgFocus: s.surface.canvas,               // --dropdown-option-bg-focus: var(--surface-canvas)
    bgSelected: s.interactive.primary.subtlePressed, // --dropdown-option-bg-selected
    padding: s.layout.gap.md,                // --dropdown-option-padding: var(--spacing-16)
    gap: s.layout.gap.sm,                    // --dropdown-option-gap: var(--spacing-8)
    radius: s.radius.sm,                     // --dropdown-option-radius: var(--radius-4)
  },
  optionGroup: {
    fg: s.text.secondary,                    // --dropdown-option-group-fg
    fontWeight: s.typography.fontWeight.semibold, // --dropdown-option-group-font-weight
  },
  clearIconFg: s.text.muted,                  // --dropdown-clear-icon-fg: var(--text-muted)
  checkmarkFg: s.text.primary,                // --dropdown-checkmark-fg: var(--text-primary)
  dropdownIconFg: s.text.secondary,           // --dropdown-icon-fg: var(--text-secondary)
  emptyMessagePadding: s.layout.gap.md,       // --dropdown-empty-message-padding
  dropdown: {
    size: s.iconSizes.lg,                    // --dropdown-trigger-size
  },
  chip: {
    borderRadius: s.radius.sm,               // --dropdown-chip-border-radius
  },
  filter: {
    height: s.controlSize.base,                 // --dropdown-filter-height (2.5rem)
    fontSize: `${s.typography.fontSize.sm} !important`,       // --dropdown-filter-font-size (0.875rem)
    iconSize: s.iconSizes.base,                // --dropdown-filter-icon-size
  },
  chevron: {
    size: s.iconSizes.xl,                    // --dropdown-chevron-size
  },  
  headerPadding: s.layout.gap.xs,           // --dropdown-header-padding
  triggerPaddingRight: s.layout.padding.sm,     // --dropdown-trigger-padding-right
  };
}
export const dropdownOverlayTokens = createDropdownOverlayTokens(SEMANTIC);